import React from "react";
import { useLocation } from "react-router-dom";

export function useQueryParams<T>() {
	const { search } = useLocation();

	return React.useMemo(
		() => Object.fromEntries(new URLSearchParams(search)),
		[search]
	) as T;
}
